import React, { useEffect } from 'react'
import styles from './AnalyzingModal.module.css'

const AnalyzingModal = ({ isOpen, onComplete, title, description, duration = 40000 }) => {
  useEffect(() => {
    if (!isOpen) {
      return
    }

    // duration 후 onComplete 호출
    const timer = setTimeout(() => {
      onComplete()
    }, duration)

    return () => clearTimeout(timer)
  }, [isOpen, onComplete, duration])

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2>{title || '결과 분석중'}</h2>
          <p>{description || '그림과 답변을 기반으로 분석중이에요.'}</p>
          <p>잠시만 기다려주세요!</p>
        </div>

        <div className={styles.loaderContainer}>
          <div className={styles.spinner}></div>
        </div>

        <div className={styles.noticeContainer}>
          <p className={styles.noticeText}>서버 환경에 따라 다소 시간이 소요될 수 있습니다</p>
        </div>
      </div>
    </div>
  )
}

export default AnalyzingModal